import React, { useEffect, useState } from 'react';
import '../styles/CookieConsent.css';
import { enableAnalytics, disableAnalytics } from '../config/analytics';
import {lang} from '../lang/';

const CookieConsent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(false);
  const isDevelopment = process.env.NODE_ENV === 'development';

  useEffect(() => {
    if (isDevelopment) {
      setShowConsent(true); // Siempre mostrar en desarrollo
      return;
    }

    const hasConsent = localStorage.getItem('cookieConsent');
    if (!hasConsent) {
      setShowConsent(true);
    }
  }, [isDevelopment]);

  const handleAccept = () => {
    if (!isDevelopment) {
      localStorage.setItem('cookieConsent', 'true');
    }
    setShowConsent(false);
    enableAnalytics();
  };

  const handleReject = () => {
    if (!isDevelopment) {
      localStorage.setItem('cookieConsent', 'false');
    }
    setShowConsent(false);
    disableAnalytics();
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <h3>{lang.CookieBanner.title}</h3>
        <p>{lang.CookieBanner.texto}</p>
        <div className="cookie-consent-buttons">
          <button onClick={handleAccept} className="accept-button">
            {lang.CookieBanner.aceptar}
          </button>
          <button onClick={handleReject} className="reject-button">
            {lang.CookieBanner.rechazar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 